import { resolveStatus } from "./StatusBadge";

/* Filter identities, in the order the chips render. */
export const FILTERS = [
  { id: "all", label: "All" },
  { id: "listed", label: "Listed" },
  { id: "claimed", label: "Claimed" },
  { id: "verified", label: "Verified" },
  { id: "members", label: "Members" },
];

/* My Companies lists only businesses the user has claimed, so "Listed" — a
   profile nobody has claimed yet — can never match there. */
export const CLAIMED_FILTERS = FILTERS.filter((f) => f.id !== "listed");

/* The one name-search rule: substring, case-insensitive, on a trimmed query. */
export const nameMatches = (name, query) => {
  const q = (query || "").trim().toLowerCase();
  if (!q) return true;
  if (!name) return false;
  return String(name).toLowerCase().includes(q);
};

/* Narrow a result list to one filter. */
export const filterCompanies = (companies = [], filter = "all") => {
  if (!Array.isArray(companies)) return [];
  if (!filter || filter === "all") return companies;
  return companies.filter((company) => {
    const { status, member } = resolveStatus(company);
    if (filter === "members") return Boolean(member);
    return status === filter;
  });
};

export default filterCompanies;
